import React from 'react';
import {
    CustomTableRowsProps,
    ContentLoader,
} from '@dev/ee-components';
import { usePaidNewsletterParamsFromUrl } from '@/components/PaidNewsletters/hooks/useRequestParams';
import { PaidNewsletterListState } from '@/store/paidNewsletters/types';

export const useLoadingPaidNewsletters = (paidNewsletters: PaidNewsletterListState) => {
    const urlParams = usePaidNewsletterParamsFromUrl();
    if (!paidNewsletters?.loadingTemplates) {
        return
    }

    const perPage = urlParams.limit || 5;
    const rows: CustomTableRowsProps[] = [];

    for (let index = 0; index < perPage; index++) {
        rows?.push({
            paidNewsletterPreview: <ContentLoader mode="row" height={20} />,
            paidNewsletterName: <ContentLoader mode="row" height={20} />,
            status: <ContentLoader mode="row" height={20} />,
            icon: <ContentLoader mode="row" height={20} />,
        });
    }

    return rows;
}